module.exports = __webpack_public_path__ + "h5/img/help3.dc43aa5f.png";